import { ANIMATE_DELAY, ANIMATED_STYLE } from "src/libs/interfaces/animated";
import { ALIGN, LANDING_TYPE_CONTENT, LINKS_DESIGN_TYPE } from "../interfaces" 
import { getID } from "src/libs/utilities";

export default function buttons(): any[] {
    return [
        {
          "id": getID("buttons"),
          "type": LANDING_TYPE_CONTENT.BUTTONS,
          "vertical_align": ALIGN.MIDDLE,  
          "horizontal_align": ALIGN.MIDDLE,
          "columns": 1,
          "animated": [ ANIMATED_STYLE.FADE_IN_LEFT, ANIMATED_STYLE.FADE_IN_RIGHT ],
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": LINKS_DESIGN_TYPE.ROUND,
          "button_color" :"var(--force-contast-color)",
          "border_width": 2,
          "style": {
            "height": 40, 
            "width": 200,
            "paddingBottom": "auto",
            "paddingLeft": 30,
            "paddingRight": 30,
            "fontWeight": 700,
            "textTransform": "uppercase",
            "fontSize": 15
          },
          items: [
            {
              id: getID("button"),
              "label": "Подробнее",
              "url" : ""
            },
            { 
              id: getID("button"),
              "label": "Ещё подробнее",
              "url" : ""
            }
          ],
          "defaultTitle": "Контрастные крупные кнопки"
        },
        {
          "id": getID("buttons"),
          "type": LANDING_TYPE_CONTENT.BUTTONS,
          "vertical_align": ALIGN.MIDDLE,  
          "horizontal_align": ALIGN.MIDDLE,
          "columns": 1,
          "animated": [ ANIMATED_STYLE.FADE_IN_LEFT, ANIMATED_STYLE.FADE_IN_RIGHT ],
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": LINKS_DESIGN_TYPE.ROUND,
          "button_color" :"var(--force-plain-color)",
          "border_width": 2,
          "style": {
            "height": 40, 
            "width": 200,
            "paddingBottom": "auto",
            "paddingLeft": 30,
            "paddingRight": 30,
            "fontWeight": 700,
            "textTransform": "uppercase",
            "fontSize": 15
          },
          items: [
            {
              id: getID("button"),
              "label": "Подробнее",
              "url" : ""
            },
            { 
              id: getID("button"),
              "label": "Ещё подробнее",
              "url" : ""
            }
          ],
          "defaultTitle": "Фоновые крупные кнопки"
        },
        {
          "id": getID("buttons"),
          "type": LANDING_TYPE_CONTENT.BUTTONS,
          "vertical_align": ALIGN.MIDDLE,  
          "horizontal_align": ALIGN.MIDDLE,
          "columns": 1,
          "animated": [ ANIMATED_STYLE.FADE_IN_LEFT, ANIMATED_STYLE.FADE_IN_RIGHT ],
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": LINKS_DESIGN_TYPE.ROUND_OUTLINE,
          "button_color" :"var(--force-contast-color)",
          "border_width": 2,
          "style": {
            "height": 40, 
            "width": 200,
            "paddingBottom": "auto",
            "paddingLeft": 30,
            "paddingRight": 30,
            "fontWeight": 700,
            "textTransform": "uppercase",
            "fontSize": 15
          },
          items: [
            {
              id: getID("button"),
              "label": "Подробнее",
              "url" : ""
            },
            { 
              id: getID("button"),
              "label": "Ещё подробнее",
              "url" : ""
            }
          ],
          "defaultTitle": "Прозрачные кнопки с конуром"
        },
        {
          "id": getID("buttons"),
          "type": LANDING_TYPE_CONTENT.BUTTONS,
          "vertical_align": ALIGN.MIDDLE,  
          "horizontal_align": ALIGN.MIDDLE,
          "columns": 1,
          "animated": [ ANIMATED_STYLE.FADE_IN_LEFT, ANIMATED_STYLE.FADE_IN_RIGHT ],
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": LINKS_DESIGN_TYPE.ROUND,
          "button_color" :"var(--actual-success-color)",
          "border_width": 2, 
          "style": {
            "height": 40, 
            "width": 200,
            "paddingBottom": "auto",
            "paddingLeft": 30,
            "paddingRight": 30,
            "fontWeight": 700,
            "textTransform": "uppercase",
            "fontSize": 15
          },
          items: [
            {
              id: getID("button"),
              "label": "Подробнее",
              "url" : ""
            },
            { 
              id: getID("button"),
              "label": "Ещё подробнее",
              "url" : ""
            }
          ],
          "defaultTitle": "Контрастные крупные зелёные кнопки"
        },
        {
          "id": getID("buttons"),
          "type": LANDING_TYPE_CONTENT.BUTTONS,
          "vertical_align": ALIGN.MIDDLE,  
          "horizontal_align": ALIGN.MIDDLE,
          "columns": 1,
          "animated": [ ANIMATED_STYLE.FADE_IN_LEFT, ANIMATED_STYLE.FADE_IN_RIGHT ],
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": LINKS_DESIGN_TYPE.ROUND,
          "button_color" :"var(--red)",
          "border_width": 2, 
          "style": {
            "height": 40, 
            "width": 200,
            "paddingBottom": "auto",
            "paddingLeft": 30,
            "paddingRight": 30,
            "fontWeight": 700,
            "textTransform": "uppercase",
            "fontSize": 15
          },
          items: [
            {
              id: getID("button"),
              "label": "Подробнее",
              "url" : ""
            },
            { 
              id: getID("button"),
              "label": "Ещё подробнее",
              "url" : ""
            }
          ],
          "defaultTitle": "Контрастные крупные красные кнопки"
        },
        {
          "id": getID("buttons"),
          "type": LANDING_TYPE_CONTENT.BUTTONS,
          "vertical_align": ALIGN.MIDDLE,  
          "horizontal_align": ALIGN.MIDDLE,
          "columns": 1,
          "animated": [ ANIMATED_STYLE.FADE_IN_LEFT, ANIMATED_STYLE.FADE_IN_RIGHT ],
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": LINKS_DESIGN_TYPE.SQUARE,
          "button_color" :"var(--force-contast-color)",
          "border_width": 2,
          "style": {
            "height": 40, 
            "width": 200,
            "paddingBottom": "auto",
            "paddingLeft": 30,
            "paddingRight": 30,
            "fontWeight": 700,
            "textTransform": "uppercase",
            "fontSize": 15
          },
          items: [
            {
              id: getID("button"),
              "label": "Подробнее",
              "url" : ""
            },
            { 
              id: getID("button"),
              "label": "Ещё подробнее",
              "url" : ""
            }
          ],
          "defaultTitle": "Контрастные крупные кнопки"
        },
        {
          "id": getID("buttons"),
          "type": LANDING_TYPE_CONTENT.BUTTONS,
          "vertical_align": ALIGN.MIDDLE,  
          "horizontal_align": ALIGN.MIDDLE,
          "columns": 1,
          "animated": [ ANIMATED_STYLE.FADE_IN_LEFT, ANIMATED_STYLE.FADE_IN_RIGHT ],
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": LINKS_DESIGN_TYPE.SQUARE,
          "button_color" :"var(--force-plain-color)",
          "border_width": 2,
          "style": {
            "height": 40, 
            "width": 200,
            "paddingBottom": "auto",
            "paddingLeft": 30,
            "paddingRight": 30,
            "fontWeight": 700,
            "textTransform": "uppercase",
            "fontSize": 15
          },
          items: [
            {
              id: getID("button"),
              "label": "Подробнее",
              "url" : ""
            },
            { 
              id: getID("button"),
              "label": "Ещё подробнее",
              "url" : ""
            }
          ],
          "defaultTitle": "Фоновые крупные кнопки"
        },
        {
          "id": getID("buttons"),
          "type": LANDING_TYPE_CONTENT.BUTTONS,
          "vertical_align": ALIGN.MIDDLE,  
          "horizontal_align": ALIGN.MIDDLE,
          "columns": 1,
          "animated": [ ANIMATED_STYLE.FADE_IN_LEFT, ANIMATED_STYLE.FADE_IN_RIGHT ],
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": LINKS_DESIGN_TYPE.OUTLINE,
          "button_color" :"var(--force-contast-color)",
          "border_width": 2,
          "style": {
            "height": 40, 
            "width": 200,
            "paddingBottom": "auto",
            "paddingLeft": 30,
            "paddingRight": 30,
            "fontWeight": 700,
            "textTransform": "uppercase",
            "fontSize": 15
          },
          items: [
            {
              id: getID("button"),
              "label": "Подробнее",
              "url" : ""
            },
            { 
              id: getID("button"),
              "label": "Ещё подробнее",
              "url" : ""
            }
          ],
          "defaultTitle": "Прозрачные кнопки с конуром"
        },
        {
          "id": getID("buttons"),
          "type": LANDING_TYPE_CONTENT.BUTTONS,
          "vertical_align": ALIGN.MIDDLE,  
          "horizontal_align": ALIGN.MIDDLE,
          "columns": 1,
          "animated": [ ANIMATED_STYLE.FADE_IN_LEFT, ANIMATED_STYLE.FADE_IN_RIGHT ],
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": LINKS_DESIGN_TYPE.SQUARE,
          "button_color" :"var(--actual-success-color)",
          "border_width": 2, 
          "style": {
            "height": 40, 
            "width": 200,
            "paddingBottom": "auto",
            "paddingLeft": 30,
            "paddingRight": 30,
            "fontWeight": 700,
            "textTransform": "uppercase",
            "fontSize": 15
          },
          items: [
            {
              id: getID("button"),
              "label": "Подробнее",
              "url" : ""
            },
            { 
              id: getID("button"),
              "label": "Ещё подробнее",
              "url" : ""
            }
          ],
          "defaultTitle": "Контрастные крупные зелёные кнопки"
        },
        {
          "id": getID("buttons"),
          "type": LANDING_TYPE_CONTENT.BUTTONS,
          "vertical_align": ALIGN.MIDDLE,  
          "horizontal_align": ALIGN.MIDDLE,
          "columns": 1,
          "animated": [ ANIMATED_STYLE.FADE_IN_LEFT, ANIMATED_STYLE.FADE_IN_RIGHT ],
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": LINKS_DESIGN_TYPE.SQUARE,
          "button_color" :"var(--red)",
          "border_width": 2, 
          "style": {
            "height": 40, 
            "width": 200,
            "paddingBottom": "auto",
            "paddingLeft": 30,
            "paddingRight": 30,
            "fontWeight": 700,
            "textTransform": "uppercase",
            "fontSize": 15
          },
          items: [
            {
              id: getID("button"),
              "label": "Подробнее",
              "url" : ""
            },
            { 
              id: getID("button"),
              "label": "Ещё подробнее",
              "url" : ""
            }
          ],
          "defaultTitle": "Контрастные крупные красные кнопки"
        },
        {
          "id": getID("buttons"),
          "type": LANDING_TYPE_CONTENT.BUTTONS,
          "vertical_align": ALIGN.MIDDLE,  
          "horizontal_align": ALIGN.MIDDLE,
          "columns": 1,
          "animated": [ ANIMATED_STYLE.FADE_IN_LEFT, ANIMATED_STYLE.FADE_IN_RIGHT ],
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": LINKS_DESIGN_TYPE.OUTLINE,
          "button_color" :"var(--actual-success-color)",
          "border_width": 2, 
          "style": {
            "height": 40, 
            "width": 200,
            "paddingBottom": "auto",
            "paddingLeft": 30,
            "paddingRight": 30,
            "fontWeight": 700,
            "textTransform": "uppercase",
            "fontSize": 15
          },
          items: [
            {
              id: getID("button"),
              "label": "Подробнее",
              "url" : ""
            },
            { 
              id: getID("button"),
              "label": "Ещё подробнее",
              "url" : ""
            }
          ],
          "defaultTitle": "Прозрачные крупные зелёные кнопки с конуром"
        },
        {
          "id": getID("buttons"),
          "type": LANDING_TYPE_CONTENT.BUTTONS,
          "vertical_align": ALIGN.MIDDLE,  
          "horizontal_align": ALIGN.MIDDLE,
          "columns": 1,
          "animated": [ ANIMATED_STYLE.FADE_IN_LEFT, ANIMATED_STYLE.FADE_IN_RIGHT ],
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": LINKS_DESIGN_TYPE.OUTLINE,
          "button_color" :"var(--red)",
          "border_width": 2, 
          "style": {
            "height": 40, 
            "width": 200,
            "paddingBottom": "auto",
            "paddingLeft": 30,
            "paddingRight": 30,
            "fontWeight": 700,
            "textTransform": "uppercase",
            "fontSize": 15
          },
          items: [
            {
              id: getID("button"),
              "label": "Подробнее",
              "url" : ""
            },
            { 
              id: getID("button"),
              "label": "Ещё подробнее",
              "url" : ""
            }
          ],
          "defaultTitle": "Прозрачные крупные красные кнопки с конуром"
        },

        {
          "id": getID("buttons"),
          "type": LANDING_TYPE_CONTENT.BUTTONS,
          "vertical_align": ALIGN.MIDDLE,  
          "horizontal_align": ALIGN.MIDDLE,
          "columns": 1,
          "animated": [ ANIMATED_STYLE.FADE_IN_LEFT, ANIMATED_STYLE.FADE_IN_RIGHT ],
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": LINKS_DESIGN_TYPE.ROUND,
          "button_color" :"var(--force-contast-color)",
          "border_width": 2,
          "style": {
            "height": 40, 
            "width": 200,
            "paddingTop": 1,
            "paddingBottom": 1,
            "paddingLeft": 15,
            "paddingRight": 15,
            "fontWeight": 100,
            "letterSpacing": 2,
            "fontSize": 10
          },
          items: [
            {
              id: getID("button"),
              "label": "Подробнее",
              "url" : ""
            },
            { 
              id: getID("button"),
              "label": "Ещё подробнее",
              "url" : ""
            }
          ],
          "defaultTitle": "Контрастные мелкие кнопки"
        },
        {
          "id": getID("buttons"),
          "type": LANDING_TYPE_CONTENT.BUTTONS,
          "vertical_align": ALIGN.MIDDLE,  
          "horizontal_align": ALIGN.MIDDLE,
          "columns": 1,
          "animated": [ ANIMATED_STYLE.FADE_IN_LEFT, ANIMATED_STYLE.FADE_IN_RIGHT ],
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": LINKS_DESIGN_TYPE.MINIMAL,
          "button_color" :"var(--force-contast-color)",
          "border_width": 2,
          "style": {
            "height": 40, 
            "width": 200,
            "paddingTop": 1,
            "paddingBottom": 1,
            "paddingLeft": 15,
            "paddingRight": 15,
            "fontWeight": 100,
            "letterSpacing": 2,
            "fontSize": 10
          },
          items: [
            {
              id: getID("button"),
              "label": "Подробнее",
              "url" : ""
            },
            { 
              id: getID("button"),
              "label": "Ещё подробнее",
              "url" : ""
            }
          ],
          "defaultTitle": "Прозрачные мелкие кнопки"
        },
        {
          "id": getID("buttons"),
          "type": LANDING_TYPE_CONTENT.BUTTONS,
          "vertical_align": ALIGN.MIDDLE,  
          "horizontal_align": ALIGN.MIDDLE,
          "columns": 1,
          "animated": [ ANIMATED_STYLE.FADE_IN_LEFT, ANIMATED_STYLE.FADE_IN_RIGHT ],
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": LINKS_DESIGN_TYPE.ROUND,
          "button_color" :"var(--force-plain-color)",
          "border_width": 2,
          "style": {
            "height": 40, 
            "width": 200,
            "paddingTop": 1,
            "paddingBottom": 1,
            "paddingLeft": 15,
            "paddingRight": 15,
            "fontWeight": 100,
            "letterSpacing": 2,
            "fontSize": 10
          },
          items: [
            {
              id: getID("button"),
              "label": "Подробнее",
              "url" : ""
            },
            { 
              id: getID("button"),
              "label": "Ещё подробнее",
              "url" : ""
            }
          ],
          "defaultTitle": "Фоновые мелкие крупные кнопки"
        },
        {
          "id": getID("buttons"),
          "type": LANDING_TYPE_CONTENT.BUTTONS,
          "vertical_align": ALIGN.MIDDLE,  
          "horizontal_align": ALIGN.MIDDLE,
          "columns": 1,
          "animated": [ ANIMATED_STYLE.FADE_IN_LEFT, ANIMATED_STYLE.FADE_IN_RIGHT ],
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": LINKS_DESIGN_TYPE.ROUND_OUTLINE,
          "button_color" :"var(--force-contast-color)",
          "border_width": 2,
          "style": {
            "height": 40, 
            "width": 200,
            "paddingTop": 1,
            "paddingBottom": 1,
            "paddingLeft": 15,
            "paddingRight": 15,
            "fontWeight": 700,
            "letterSpacing": 2,
            "fontSize": 10
          },
          items: [
            {
              id: getID("button"),
              "label": "Подробнее",
              "url" : ""
            },
            { 
              id: getID("button"),
              "label": "Ещё подробнее",
              "url" : ""
            }
          ],
          "defaultTitle": "Прозрачные мелкие кнопки с конуром"
        },
        {
          "id": getID("buttons"),
          "type": LANDING_TYPE_CONTENT.BUTTONS,
          "vertical_align": ALIGN.MIDDLE,  
          "horizontal_align": ALIGN.MIDDLE,
          "columns": 1,
          "animated": [ ANIMATED_STYLE.FADE_IN_LEFT, ANIMATED_STYLE.FADE_IN_RIGHT ],
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": LINKS_DESIGN_TYPE.ROUND,
          "button_color" :"var(--actual-success-color)",
          "border_width": 2, 
          "style": {
            "height": 40, 
            "width": 200,
            "paddingTop": 1,
            "paddingBottom": 1,
            "paddingLeft": 15,
            "paddingRight": 15,
            "fontWeight": 100,
            "letterSpacing": 2,
            "fontSize": 10
          },
          items: [
            {
              id: getID("button"),
              "label": "Подробнее",
              "url" : ""
            },
            { 
              id: getID("button"),
              "label": "Ещё подробнее",
              "url" : ""
            }
          ],
          "defaultTitle": "Контрастные мелкие зелёные кнопки"
        },
        {
          "id": getID("buttons"),
          "type": LANDING_TYPE_CONTENT.BUTTONS,
          "vertical_align": ALIGN.MIDDLE,  
          "horizontal_align": ALIGN.MIDDLE,
          "columns": 1,
          "animated": [ ANIMATED_STYLE.FADE_IN_LEFT, ANIMATED_STYLE.FADE_IN_RIGHT ],
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": LINKS_DESIGN_TYPE.ROUND,
          "button_color" :"var(--red)",
          "border_width": 2, 
          "style": {
            "height": 40, 
            "width": 200,
            "paddingTop": 1,
            "paddingBottom": 1,
            "paddingLeft": 15,
            "paddingRight": 15,
            "fontWeight": 100,
            "letterSpacing": 2,
            "fontSize": 10
          },
          items: [
            {
              id: getID("button"),
              "label": "Подробнее",
              "url" : ""
            },
            { 
              id: getID("button"),
              "label": "Ещё подробнее",
              "url" : ""
            }
          ],
          "defaultTitle": "Контрастные мелкие красные кнопки"
        },
        {
          "id": getID("buttons"),
          "type": LANDING_TYPE_CONTENT.BUTTONS,
          "vertical_align": ALIGN.MIDDLE,  
          "horizontal_align": ALIGN.MIDDLE,
          "columns": 1,
          "animated": [ ANIMATED_STYLE.FADE_IN_LEFT, ANIMATED_STYLE.FADE_IN_RIGHT ],
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": LINKS_DESIGN_TYPE.SQUARE,
          "button_color" :"var(--force-contast-color)",
          "border_width": 2,
          "style": {
            "height": 40, 
            "width": 200,
            "paddingTop": 1,
            "paddingBottom": 1,
            "paddingLeft": 15,
            "paddingRight": 15,
            "fontWeight": 100,
            "letterSpacing": 2,
            "fontSize": 10
          },
          items: [
            {
              id: getID("button"),
              "label": "Подробнее",
              "url" : ""
            },
            { 
              id: getID("button"),
              "label": "Ещё подробнее",
              "url" : ""
            }
          ],
          "defaultTitle": "Контрастные мелкие кнопки"
        },
        {
          "id": getID("buttons"),
          "type": LANDING_TYPE_CONTENT.BUTTONS,
          "vertical_align": ALIGN.MIDDLE,  
          "horizontal_align": ALIGN.MIDDLE,
          "columns": 1,
          "animated": [ ANIMATED_STYLE.FADE_IN_LEFT, ANIMATED_STYLE.FADE_IN_RIGHT ],
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": LINKS_DESIGN_TYPE.SQUARE,
          "button_color" :"var(--force-plain-color)",
          "border_width": 2,
          "style": {
            "height": 40, 
            "width": 200,
            "paddingTop": 1,
            "paddingBottom": 1,
            "paddingLeft": 15,
            "paddingRight": 15,
            "fontWeight": 100,
            "letterSpacing": 2,
            "fontSize": 10
          },
          items: [
            {
              id: getID("button"),
              "label": "Подробнее",
              "url" : ""
            },
            { 
              id: getID("button"),
              "label": "Ещё подробнее",
              "url" : ""
            }
          ],
          "defaultTitle": "Фоновые мелкие кнопки"
        },
        {
          "id": getID("buttons"),
          "type": LANDING_TYPE_CONTENT.BUTTONS,
          "vertical_align": ALIGN.MIDDLE,  
          "horizontal_align": ALIGN.MIDDLE,
          "columns": 1,
          "animated": [ ANIMATED_STYLE.FADE_IN_LEFT, ANIMATED_STYLE.FADE_IN_RIGHT ],
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": LINKS_DESIGN_TYPE.OUTLINE,
          "button_color" :"var(--force-contast-color)",
          "border_width": 2,
          "style": {
            "height": 40, 
            "width": 200,
            "paddingTop": 1,
            "paddingBottom": 1,
            "paddingLeft": 15,
            "paddingRight": 15,
            "fontWeight": 700,
            "letterSpacing": 2,
            "fontSize": 10
          },
          items: [
            {
              id: getID("button"),
              "label": "Подробнее",
              "url" : ""
            },
            { 
              id: getID("button"),
              "label": "Ещё подробнее",
              "url" : ""
            }
          ],
          "defaultTitle": "Прозрачные мелкие кнопки с конуром"
        },
        {
          "id": getID("buttons"),
          "type": LANDING_TYPE_CONTENT.BUTTONS,
          "vertical_align": ALIGN.MIDDLE,  
          "horizontal_align": ALIGN.MIDDLE,
          "columns": 1,
          "animated": [ ANIMATED_STYLE.FADE_IN_LEFT, ANIMATED_STYLE.FADE_IN_RIGHT ],
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": LINKS_DESIGN_TYPE.SQUARE,
          "button_color" :"var(--actual-success-color)",
          "border_width": 2, 
          "style": {
            "height": 40, 
            "width": 200,
            "paddingTop": 1,
            "paddingBottom": 1,
            "paddingLeft": 15,
            "paddingRight": 15,
            "fontWeight": 100,
            "letterSpacing": 2,
            "fontSize": 10
          },
          items: [
            {
              id: getID("button"),
              "label": "Подробнее",
              "url" : ""
            },
            { 
              id: getID("button"),
              "label": "Ещё подробнее",
              "url" : ""
            }
          ],
          "defaultTitle": "Контрастные мелкие зелёные кнопки"
        },
        {
          "id": getID("buttons"),
          "type": LANDING_TYPE_CONTENT.BUTTONS,
          "vertical_align": ALIGN.MIDDLE,  
          "horizontal_align": ALIGN.MIDDLE,
          "columns": 1,
          "animated": [ ANIMATED_STYLE.FADE_IN_LEFT, ANIMATED_STYLE.FADE_IN_RIGHT ],
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": LINKS_DESIGN_TYPE.SQUARE,
          "button_color" :"var(--red)",
          "border_width": 2, 
          "style": {
            "height": 40, 
            "width": 200,
            "paddingTop": 1,
            "paddingBottom": 1,
            "paddingLeft": 15,
            "paddingRight": 15,
            "fontWeight": 100,
            "letterSpacing": 2,
            "fontSize": 10
          },
          items: [
            {
              id: getID("button"),
              "label": "Подробнее",
              "url" : ""
            },
            { 
              id: getID("button"),
              "label": "Ещё подробнее",
              "url" : ""
            }
          ],
          "defaultTitle": "Контрастные мелкие красные кнопки"
        },
        {
          "id": getID("buttons"),
          "type": LANDING_TYPE_CONTENT.BUTTONS,
          "vertical_align": ALIGN.MIDDLE,  
          "horizontal_align": ALIGN.MIDDLE,
          "columns": 1,
          "animated": [ ANIMATED_STYLE.FADE_IN_LEFT, ANIMATED_STYLE.FADE_IN_RIGHT ],
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": LINKS_DESIGN_TYPE.OUTLINE,
          "button_color" :"var(--actual-success-color)",
          "border_width": 2, 
          "style": {
            "height": 40, 
            "width": 200,
            "paddingTop": 1,
            "paddingBottom": 1,
            "paddingLeft": 15,
            "paddingRight": 15,
            "fontWeight": 700,
            "letterSpacing": 2,
            "fontSize": 10
          },
          items: [
            {
              id: getID("button"),
              "label": "Подробнее",
              "url" : ""
            },
            { 
              id: getID("button"),
              "label": "Ещё подробнее",
              "url" : ""
            }
          ],
          "defaultTitle": "Прозрачные мелкие зелёные кнопки с конуром"
        },
        {
          "id": getID("buttons"),
          "type": LANDING_TYPE_CONTENT.BUTTONS,
          "vertical_align": ALIGN.MIDDLE,  
          "horizontal_align": ALIGN.MIDDLE,
          "columns": 1,
          "animated": [ ANIMATED_STYLE.FADE_IN_LEFT, ANIMATED_STYLE.FADE_IN_RIGHT ],
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": LINKS_DESIGN_TYPE.OUTLINE,
          "button_color" :"var(--red)",
          "border_width": 2, 
          "style": {
            "height": 40, 
            "width": 200,
            "paddingTop": 1,
            "paddingBottom": 1,
            "paddingLeft": 15,
            "paddingRight": 15,
            "fontWeight": 700,
            "letterSpacing": 2,
            "fontSize": 10
          },
          items: [
            {
              id: getID("button"),
              "label": "Подробнее",
              "url" : ""
            },
            { 
              id: getID("button"),
              "label": "Ещё подробнее",
              "url" : ""
            }
          ],
          "defaultTitle": "Прозрачные мелкие красные кнопки с конуром"
        },
    ]
}